<template>
    <div class="container-fluid">
      <div
        class="page-header min-height-100"
      >
        
      </div>
      <div class="card shadow-lg mt-n6">
        <div class="card-body p-3">
          <div class="row gx-4">
            <div class="col-auto">
              <div class="avatar avatar-xl position-relative">

              </div>
            </div>
            <div class="col-auto my-auto">
              <div class="h-100">
                <h5 class="mb-1">{{data.nome_completo || "Novo Entregador"}}</h5>
                <p class="mb-0 font-weight-bold text-sm"></p>
              </div>
            </div>
            <div
              class="mx-auto mt-3 col-lg-4 col-md-6 my-sm-auto ms-sm-auto me-sm-0"
            >
              <div class="nav-wrapper position-relative end-0">
                <ul
                  class="p-1 bg-transparent nav nav-pills nav-fill"
                  role="tablist"
                >
                  <li class="nav-item">
                    
                      <button
                        class="mb-0 btn bg-gradient-success btn-sm me-2"
                        type="button"
                        name="button"
                        @click="salvarUnico(data)"
                      >
                        Salvar
                      </button>

                  </li>
                  <li class="nav-item">
                      <button
                        class="mb-0 btn btn-outline-danger btn-sm"
                        type="button"
                        name="button"
                        @click="fecharUnico()"
                      >
                        Cancelar
                      </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
  <div class="py-4 container-fluid">
    <div class="mt-4 row">
      <div class="mt-4 col-lg-8 mt-lg-0">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-sm-6">
                <label>Nome</label>
                <input
                  class="form-control"
                  type="text"
                  v-model="data.nome_completo"
                />
              </div>
              <div class="col-12 col-sm-6">
                <label>Cpf</label>
                <input
                  class="form-control"
                  type="text"
                  v-model="data.cpf"
                />
              </div>
              <div class="col-12 col-sm-12">
                <label>Email</label>
                <input
                  class="form-control"
                  type="text"
                  v-model="data.email"
                />
              </div>
              
            </div>
            <div class="row">
              <div class="col-3">
                <label class="mt-4">Data Nascimento</label>
                <input class="form-control" type="text" v-model="data.data_nascimento" />
              </div>
              <div class="col-3">
                <label class="mt-4">Telefone</label>
                <input class="form-control" type="number" v-model="data.telefone" />
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <label class="mt-4">Numero CNH</label>
                <input class="form-control" type="text" v-model="data.numero_cnh" />
              </div>
              <div class="col-sm-3">
                <label class="mt-4">Categoria CNH</label>
                <select
                  id="choices-category-edit"
                  class="form-control"
                  name="choices-category"
                  v-model="data.categoria_cnh"
                >
                  <option value="A" selected>A</option>
                  <option value="B">B</option>
                  <option value="AB">AB</option>
                  <option value="C">C</option>
                  <option value="D">D</option>
                  <option value="E">E</option>
                </select>

              </div>
              <div class="col-sm-6">

                    <label class="mt-4">Disponibilidade</label>
                    <select
                      id="choices-color-edit"
                      class="form-control"
                      name="choices-color"
                      v-model="data.status"
                    >
                      <option value="Disponível" selected>Disponível</option>
                      <option value="Indisponível">Indisponível</option>
                    </select>

                </div>
                <div class="col-sm-6">
                  <label>Operação</label>
                  <select
                    id="choices-category"
                    class="form-control"
                    name="choices-category"
                    v-model="data.operacao_id"
                  >
                  <option v-for="item in operacoes" :key="item.id" :value="item.id">
                    {{ item.name }}
                  </option>
                  </select>
                 
                </div>
                <div class="col-sm-5">
                  <label>Veículo Atual</label>
                  <select
                    id="choices-category"
                    class="form-control"
                    name="choices-category"
                    v-model="data.veiculo_id"
                  >
                    <option disabled value="">Selecione um Veículo</option>
                    <option value="nenhum">Nenhum Veículo</option>
                    <option v-for="m in veiculos" :key="m.id" :value="m.id">
                      {{ m.marca }}
                    </option>
                  </select>
                 
                </div>
                <div class="col-sm-1 mt-1">
                  <label></label><br>
                    <button
                      class="btn btn-outline-danger btn-sm"
                      type="button"
                      @click="goVeiculos()"
                    >
                      Novo
                    </button>
               </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { useRouter } from 'vue-router';

export default {
  name: "FormularioVeiculo",
  props: {
      data: {
        type: Object,
        default: () => {
          {};
        },
      },
      operacoes: {
        type: Array,
        default: () => {
          [];
        },
      },
      veiculos: {
        type: Array,
        default: () => {
          [];
        },
      },
      salvarUnico: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      fecharUnico: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      }
    },
  mounted() {


  },
  setup(props) {

      const router = useRouter();

      const salvarUnico = (data) => {
          props.salvarUnico(data); // Define o novo cen tro do mapa
      };

      const fecharUnico = () => {
          props.fecharUnico(); // Define o novo cen tro do mapa
      };

      const goVeiculos = () => {
        router.push('/veiculos/criar');
      }

      // Retorna os métodos ou variáveis que você quer expor
      return {
        salvarUnico,
        fecharUnico,
        goVeiculos
      };
  }
};
</script>
